export const ATTRIBUTE_CARD_TITLE_CLASSES =
  "p-2.5 border-b border-gray-100 font-bold text-sm bg-slate-100";
